(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-buy-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bar = document.querySelector('[data-sh-buybar]');
    if (!bar) return;
    function onScroll() {
      var show = window.scrollY > 480;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    var addBtn = bar.querySelector('[data-sh-buybar-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var main =
          document.querySelector('product-form-component .add-to-cart-button') ||
          document.querySelector('form[data-type="add-to-cart-form"] .add-to-cart-button') ||
          document.querySelector('product-form-component button[type="submit"]');
        if (main) { main.click(); }
      });
    }

    var barPrice = bar.querySelector('[data-sh-buybar-price]');
    if (barPrice) {
      // Re-cherche l'element prix a CHAQUE synchro : Horizon remplace le noeud
      // au changement de variante, un observateur fige sur l'ancien noeud rate tout.
      var sync = function () {
        var mainPrice =
          document.querySelector('.group-block-content product-price .price') ||
          document.querySelector('product-form-component .price') ||
          document.querySelector('.product-information .price');
        var t = mainPrice ? (mainPrice.textContent || '').trim() : '';
        if (t) { barPrice.textContent = t; }
      };
      sync();
      document.addEventListener('change', function () { setTimeout(sync, 150); setTimeout(sync, 600); });
      var container = document.querySelector('.product-information') || document.body;
      try { new MutationObserver(function () { setTimeout(sync, 50); }).observe(container, { childList: true, subtree: true }); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'sh_popup_v1';
  var root = document.querySelector('[data-sh-popup]');
  if (!root) return;

  var intro = root.querySelector('[data-sh-popup-intro]');
  var success = root.querySelector('[data-sh-popup-success]');
  var form = root.querySelector('#sh-popup-form');
  var errBox = root.querySelector('[data-sh-popup-err]');
  var tab = document.querySelector('[data-sh-popup-tab]');

  var seen = false;
  try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
  function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

  function showTab() { if (tab) tab.classList.add('is-shown'); }
  function hideTab() { if (tab) tab.classList.remove('is-shown'); }

  // Mobile : l'onglet ne sort qu'apres un debut de scroll (voir CSS max-600px)
  function onTabScroll() { if (tab) tab.classList.toggle('is-scrolled', window.scrollY > 200); }
  window.addEventListener('scroll', onTabScroll, { passive: true });
  onTabScroll();

  function open() {
    hideTab();
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    var input = root.querySelector('input[type="email"]');
    if (input && intro && !intro.hidden) setTimeout(function () { input.focus(); }, 350);
  }
  function close() {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 340);
    markSeen();
    showTab();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  // L'onglet lateral rouvre le pop-up (sur l'ecran d'inscription)
  if (tab) {
    tab.addEventListener('click', function () {
      if (intro && success) { intro.hidden = false; success.hidden = true; }
      open();
    });
  }

  function showSuccess() {
    if (intro) intro.hidden = true;
    if (success) success.hidden = false;
    markSeen();
  }

  root.querySelectorAll('[data-sh-popup-close]').forEach(function (el) { el.addEventListener('click', close); });

  // Copier le code
  var copyBtn = root.querySelector('[data-sh-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-sh-copy') || '';
      var done = function () { copyBtn.textContent = copyBtn.getAttribute('data-sh-copied') || 'Copié !'; };
      if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
    });
  }

  // Soumission NATIVE (evite le challenge anti-robot du POST XHR sur /contact).
  // Deux chemins couverts : rechargement complet (?customer_posted=true) OU
  // interception AJAX d'Horizon (pas de navigation -> revele apres un court delai).
  if (form) {
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('sh_popup_pending', '1'); } catch (e) {}
      var btn = form.querySelector('.sh-popup__submit');
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-sh-wait') || 'Un instant...'; }
      setTimeout(function () { showSuccess(); }, 1500); // ne s'execute que si la page ne recharge pas
    });
  }

  // Retour apres inscription reussie (rechargement) OU reprise du flag en attente
  var pending = false;
  try { pending = sessionStorage.getItem('sh_popup_pending') === '1'; } catch (e) {}
  if (/[?&]customer_posted=true/.test(window.location.search) || pending) {
    try { sessionStorage.removeItem('sh_popup_pending'); } catch (e) {}
    showSuccess(); markSeen(); open(); return;
  }

  // Visiteur ayant deja ferme le pop-up : on montre l'onglet pour le rouvrir
  if (seen) { showTab(); return; }

  var fired = false;
  function fire() { if (fired) return; fired = true; open(); }
  var delay = parseInt(root.getAttribute('data-delay'), 10);
  if (isNaN(delay)) delay = 7;
  var timer = setTimeout(fire, delay * 1000);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); fire(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
